import React, { useEffect, useState } from "react";
import { MDBContainer, MDBTabsContent, MDBTabsPane } from "mdb-react-ui-kit";
import { Form } from "react-bootstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faPlusCircle } from "@fortawesome/free-solid-svg-icons";
// import { GoogleLogin, useGoogleLogin } from "@react-oauth/google";
import lang from "../../../assets/lang/toastMsg.json";
import BodyLoading from "../../modules/Loading/BodyLoading";
import { faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";

export default function LoginTemp() {
  const [justifyActive, setJustifyActive] = useState("tab1");
  const Navigator = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isRevealPwd, setIsRevealPwd] = useState(false);
  const [loginInput, setLogin] = useState({
    email: "",
    password: "",
  });

  const [registerInput, setRegister] = useState({
    name: "",
    email: "",
    password: "",
  });

  const handleLoginInput = (e) => {
    e.persist();

    setLogin({ ...loginInput, [e.target.name]: e.target.value });
  };

  const handleRegisterInput = (e) => {
    e.persist();

    setRegister({ ...registerInput, [e.target.name]: e.target.value });
  };

  //Login
  const handleLogin = async (e) => {
    e.preventDefault();

    if (loginInput.email === "") {
      toast.dismiss();
      toast.error(`${lang.emailRequired}`, {
        closeOnClick: true,
        theme: "colored",
      });
    } else if (loginInput.password === "") {
      toast.dismiss();
      toast.error(`${lang.passwordRequired}`, {
        closeOnClick: true,
        theme: "colored",
      });
    } else {
      const data = {
        email: loginInput.email,
        password: loginInput.password,
      };
      try {
        setLoading(true);

        const response = await axios.post("/login", data);
        if (response.data.status === 401) {
          toast.dismiss();
          toast.dismiss();
          toast.error(response.data.message, {
            closeOnClick: true,
            theme: "colored",
          });
        } else if (response.data.status === 200) {
          if (response.data.role === "admin") {
            Navigator("/admin/dashboard");
          } else {
            Navigator("/my-signatures");
          }
          const userdata = {
            name: response.data.userData.name,
            email: response.data.userData.email,
            id: response.data.userData.id,
          };
          const responseString = JSON.stringify(userdata);

          localStorage.setItem("auth_token", response.data.token);
          localStorage.setItem("user", responseString);
        }
        setLoading(false);
      } catch (error) {
        console.log(error);
      }
    }
  };

  //Register
  const handleRegister = async (e) => {
    e.preventDefault();

    var passwordValidate =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/i;

    if (registerInput.name === "") {
      toast.dismiss();
      toast.error(`${lang.nameRequired}`, {
        closeOnClick: true,
        theme: "colored",
      });
    } else if (registerInput.email === "") {
      toast.dismiss();
      toast.error(`${lang.emailRequired}`, {
        closeOnClick: true,
        theme: "colored",
      });
    } else if (registerInput.password === "") {
      toast.dismiss();
      toast.error(`${lang.passwordRequired}`, {
        closeOnClick: true,
        theme: "colored",
      });
    } else if (!passwordValidate.test(registerInput.password)) {
      toast.dismiss();
      toast.error(`${lang.passwordValid}`, {
        closeOnClick: true,
        theme: "colored",
      });
    } else {
      const data = {
        name: registerInput.name,
        email: registerInput.email,
        password: registerInput.password,
      };
      try {
        setLoading(true);
        const response = await axios.post("/register", data);
        if (response.data.status === 401) {
          toast.dismiss();
          toast.error(response.data.validator_error.email[0], {
            closeOnClick: true,
            theme: "colored",
          });
        } else if (response.data.status === 200) {
          Navigator("/my-signatures");

          const userdata = {
            name: response.data.userData.name,
            email: response.data.userData.email,
            id: response.data.userData.id,
          };
          const responseString = JSON.stringify(userdata);

          localStorage.setItem("auth_token", response.data.token);
          localStorage.setItem("user", responseString);
        }
        setLoading(false);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleJustifyClick = (value) => {
    if (value === justifyActive) {
      return;
    }

    setJustifyActive(value);
  };

  // const responseMessage = (response) => {
  //   console.log(response);
  //   axios.get("/google/callback/" + response);
  // };
  // const errorMessage = (error) => {
  //   console.log(error);
  // };

  // google api call
  // const [googleResponse, setGoogleResponse] = useState("");
  // const login = useGoogleLogin({
  //   onSuccess: (codeResponse) => setGoogleResponse(codeResponse),
  // });
  // console.log(googleResponse);

  // useEffect(() => {
  //   setTimeout(() => {
  //     if (googleResponse !== "") {
  //       axios
  //         .get(
  //           `https://www.googleapis.com/oauth2/v3/userinfo?access_token=${googleResponse.access_token}`,
  //           {
  //             headers: {
  //               "Access-Control-Allow-Origin":
  //                 "https://websitedemonow.com/signature/",
  //               Accept: "application/json",
  //               server: "ESF",
  //             },
  //           }
  //         )
  //         .then((res) => {
  //           console.log(res);
  //         })
  //         .catch((error) => console.log("error", error));
  //     }
  //   }, 2000);
  // }, [googleResponse]);
  document.title = "Login";
  return (
    <>
      {loading ? <BodyLoading /> : null}
      <div className="col-6">
        <MDBContainer
          className=" text-dark p-4 w-75 d-flex flex-column m-0 shadow"
          style={{
            borderRadius: "12px",
            background: "white ",
          }}
        >
          {/* <MDBTabs pills justify className='mb-3 d-flex flex-row justify-content-between'>
                <MDBTabsItem>
                    <MDBTabsLink onClick={() => handleJustifyClick('tab1')} active={justifyActive === 'tab1' ? justifyActive === 'tab1' : ''} >
                        Login
                    </MDBTabsLink>
                </MDBTabsItem>
                <MDBTabsItem>
                    <MDBTabsLink onClick={() => handleJustifyClick('tab2')} active={justifyActive === 'tab2' ? justifyActive === 'tab2' : ''}>
                        Register
                    </MDBTabsLink>
                </MDBTabsItem>
            </MDBTabs> */}

          <MDBTabsContent>
            <MDBTabsPane show={justifyActive === "tab1"}>
              <div className=" mb-3">
                <h2>Login</h2>
              </div>
              {/* <button className="btn btn-primary" onClick={login}>
                Login with google
              </button> */}
              <Form onSubmit={handleLogin}>
                <div className="form-group mb-3">
                  <label>Email </label>
                  <input
                    type="email"
                    name="email"
                    onChange={handleLoginInput}
                    value={loginInput.email}
                    className="form-control"
                    required
                  />
                  {/* <span className='text-danger'>{loginInput.validator_error.email}</span> */}
                </div>
                <div className="form-group mb-3 position-relative">
                  <label>Password</label>
                  <input
                    type={isRevealPwd ? "text" : "password"}
                    name="password"
                    onChange={handleLoginInput}
                    autoComplete="off"
                    value={loginInput.password}
                    className="form-control"
                    required
                  />
                  <span
                    style={{ position: "absolute", right: "5%", top: "50%" }}
                    onClick={() => setIsRevealPwd((prevState) => !prevState)}
                  >
                    {isRevealPwd ? (
                      <FontAwesomeIcon icon={faEye} title="Hide Password" />
                    ) : (
                      <FontAwesomeIcon
                        icon={faEyeSlash}
                        title="Show Password"
                      />
                    )}
                  </span>

                  {/* <span className='text-danger'>{loginInput.validator_error.password}</span> */}
                </div>

                <div className="form-group">
                  <button type="submit" className="btn btn-primary w-100">
                    Login
                  </button>
                </div>
              </Form>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div
                  style={{
                    height: "1px",
                    width: "100%",
                    background: " rgb(209, 213, 219)",
                  }}
                ></div>
                <p
                  style={{
                    margin: "10px",
                    fontWeight: "100",
                    color: "rgb(148, 151, 156)",
                  }}
                >
                  OR
                </p>
                <div
                  style={{
                    height: "1px",
                    width: "100%",
                    background: " rgb(209, 213, 219)",
                  }}
                ></div>
              </div>
              <div className="form-group mb-3">
                <button
                  type="submit"
                  className="btn btn-success w-100"
                  onClick={() => handleJustifyClick("tab2")}
                  // active={
                  //   justifyActive === "tab2"
                  //     ? justifyActive === "tab2"
                  //     : undefined
                  // }
                >
                  <FontAwesomeIcon icon={faPlusCircle} /> Create Account
                </button>
              </div>
            </MDBTabsPane>

            <MDBTabsPane
              show={
                justifyActive === "tab2" ? justifyActive === "tab2" : undefined
              }
            >
              <div className=" mb-3">
                <h2>Sign Up</h2>
              </div>
              <Form onSubmit={handleRegister}>
                <div className="form-group mb-3">
                  <label>Name</label>
                  <input
                    type="text"
                    name="name"
                    onChange={handleRegisterInput}
                    value={registerInput.name}
                    className="form-control"
                    required
                  />
                  {/* <span className='text-danger'>{registerInput.validator_error.password}</span> */}
                </div>
                <div className="form-group mb-3">
                  <label>Email </label>
                  <input
                    type="email"
                    name="email"
                    onChange={handleRegisterInput}
                    value={registerInput.email}
                    className="form-control"
                    required
                  />
                  {/* <span className='text-danger'>{registerInput.validator_error.email}</span> */}
                </div>
                <div className="form-group mb-3">
                  <label>Password</label>
                  <input
                    type="password"
                    name="password"
                    onChange={handleRegisterInput}
                    autoComplete="off"
                    value={registerInput.password}
                    className="form-control"
                    required
                  />
                  {/* <span className='text-danger'>{registerInput.validator_error.password}</span> */}
                </div>

                <div className="form-group ">
                  <button type="submit" className="btn btn-secondary w-100">
                    Create Account
                  </button>
                </div>
              </Form>
              {/* <GoogleLogin onSuccess={responseMessage} onError={errorMessage} /> */}

              <div style={{ display: "flex", alignItems: "center" }}>
                <div
                  style={{
                    height: "1px",
                    width: "100%",
                    background: " rgb(209, 213, 219)",
                  }}
                ></div>
                <p
                  style={{
                    margin: "10px",
                    fontWeight: "100",
                    color: "rgb(148, 151, 156)",
                  }}
                >
                  OR
                </p>
                <div
                  style={{
                    height: "1px",
                    width: "100%",
                    background: " rgb(209, 213, 219)",
                  }}
                ></div>
              </div>
              <div className="form-group mb-3">
                <button
                  type="submit"
                  className="btn btn-success w-100"
                  onClick={() => handleJustifyClick("tab1")}
                  // active={
                  //   justifyActive === "tab1"
                  //     ? justifyActive === "tab1"
                  //     : undefined
                  // }
                >
                  <FontAwesomeIcon icon={faArrowLeft} /> Back ot Login
                </button>
              </div>
            </MDBTabsPane>
          </MDBTabsContent>
        </MDBContainer>
      </div>
      {/* <div className='col-6  bg-danger'>
                <img src="https://images.unsplash.com/photo-1566888596782-c7f41cc184c5?ixlib=rb-1.2.1&amp;auto=format&amp;fit=crop&amp;w=2134&amp;q=80" class="img-fluid" />
            </div> */}
    </>
  );
}
